import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { handleTrack } from '../../../../../utils/tracker';
import {
  DEFAULT_ACTIVE_HORIZONTAL_TAB,
  DEFAULT_ACTIVE_VERTICAL_TAB,
} from '../../constants';
import { DETAILED_STEP_DATA } from '../../data/detailed-step.data';
import { TabHeader } from './TabHeader';

export const HorizontalTab = () => {
  const [activeTab, setActiveTab] = useState<string>(
    DEFAULT_ACTIVE_HORIZONTAL_TAB
  );
  const [currentActiveVerticalTab, setCurrentVerticalTab] = useState(
    DEFAULT_ACTIVE_VERTICAL_TAB
  );

  const router = useRouter();

  useEffect(() => {
    const { tab } = router.query;
    if (tab) setCurrentVerticalTab(tab as string);
  }, [router.query]);

  const stepData = DETAILED_STEP_DATA(currentActiveVerticalTab);
  const content = stepData.find((item) => item.id === activeTab)?.content;

  const handleOnTabChange = (tabId: string) => {
    handleTrack({ label: `guide_${tabId}` });
    setActiveTab(tabId);
  };

  return (
    <div className="w-full">
      <TabHeader activeTab={activeTab} handleOnTabChange={handleOnTabChange} />
      <div>{content}</div>
    </div>
  );
};
